import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tabs, Tab } from 'react-bootstrap';
import get from 'lodash/get';
import Settings from '../../../../../components/publisher/email_templates/EmailTemplateSettings';
import Custom from '../../../../../components/publisher/email_templates/EmailTemplateCustom';
import Builder from '../../../../../components/publisher/email_templates/EmailTemplateBuilder';
import Test from '../../../../../components/publisher/email_templates/EmailTemplateTest';

import { PublisherApi } from '../../../../../api';

class EmailTemplateEdit extends Component {
  state = { key: 1 };

  componentDidMount() {
    this.fetchResource();
    this.fetchPixel();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.website.uuid !== this.props.website.uuid) {
      this.fetchResource();
      this.fetchPixel();
    }
  }

  fetchResource(params = {}) {
    const { website, dispatch } = this.props;
    const emailTemplate = get(this.props, 'emailTemplate.data', {});

    if (website.uuid && emailTemplate.publisher_website_id !== website.uuid) {
      const data = { ...params, publisher_website_id: website.uuid };
      dispatch(PublisherApi.actions.emailTemplate.get(data));  
    }
  }

  fetchPixel(params = {}) {
    const { website, dispatch } = this.props;
    const pixel = get(this.props, 'pixel.data', {});
    if (website.uuid && pixel.publisher_website_id !== website.uuid) {
      const data = { ...params, publisher_website_id: website.uuid };
      dispatch(PublisherApi.actions.pixel.get(data));  
    }
  }

  handleTabSelect(key) {
    this.setState({ key });
  }

  render() {
    const { website, emailTemplate, pixel } = this.props;

    return (
      <div className='ibox'>
        <div className='ibox-title'>
          <h5>Email Template</h5>      
        </div>
        <div className='ibox-content' style={{ overflow: 'auto' }}>
          {website.publisher_c_name_id ? 
          <Tabs 
            activeKey={this.state.key} 
            onSelect={this.handleTabSelect.bind(this)} 
            id="controlled-tab"
            style={{ minWidth: 400 }}
          >
            <Tab unmountOnExit eventKey={1} title="Settings" className='p-md'>
              <Settings website={website} emailTemplate={emailTemplate} pixel={pixel} />
            </Tab>
            <Tab unmountOnExit eventKey={2} title="Custom" className='p-md'>
              <Custom website={website} emailTemplate={emailTemplate} pixel={pixel} />
            </Tab>
            <Tab unmountOnExit eventKey={3} title="Builder" className='p-md'>
              <Builder website={website} emailTemplate={emailTemplate} pixel={pixel} />
            </Tab>
             <Tab unmountOnExit eventKey={4} title="Test Email" className='p-md'>
              <Test website={website} emailTemplate={emailTemplate} pixel={pixel} />
            </Tab>
          </Tabs> : <p className="text-center">
            No CNAME associated with this website. Please choose a CNAME for this website to access the email template settings!
          </p> }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { publisher, publisher: { websites } } = state;
  const { params: { websiteName } } = ownProps;
  const website = (websites.data.data || [])
    .filter((w) => w.slug === websiteName)[0] || {};

  return { 
    emailTemplate: get(publisher, 'emailTemplate.data.data', {}),
    pixel: get(publisher, 'pixel.data.data', {}),
    website
  };
};

export default connect(mapStateToProps)(EmailTemplateEdit);
